import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {CheckboxComponent} from './components/formfields/checkbox/checkbox.component';
import {PanelComponent} from './components/panel/panel.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputComponent} from './components/formfields/input/input.component';
import {SelectComponent} from './components/formfields/select/select.component';
import {KachelComponent} from './components/kachel/kachel.component';
import {JaNeinRadioComponent} from './components/formfields/ja-nein-radio/ja-nein-radio.component';
import {DatepickerComponent} from './components/formfields/datepicker/datepicker.component';
import {NichtVorhandenDirective} from './directives/nicht-vorhanden.directive';
import {FragezeichenComponent} from './components/fragezeichen/fragezeichen.component';
import {ButtonLeisteComponent} from './components/button-leiste/button-leiste.component';
import {ErrorMessageComponent} from './components/error-message/error-message.component';
import {ModalDialogComponent} from './components/dialogs/modal-dialog/modal-dialog.component';
import {TextareaComponent} from './components/formfields/textarea/textarea.component';
import {InputSuggestionComponent} from './components/formfields/input-suggestion/input-suggestion.component';
import {GeoFilterPipe} from './pipes/geo-filter-pipe.pipe';
import {LoeschenDialogComponent} from './components/dialogs/loeschen-dialog/loeschen-dialog.component';
import {DateConverterService} from './converters/date-converter.service';
import {FileUploadComponent} from './components/file-upload/file-upload.component';
import {ProgressNavigationComponent} from './components/progress-navigation/progress-navigation.component';
import {HideExtPipe} from './components/file-upload/hide-ext.pipe';
import {FehlerBoxComponent} from './components/fehler-box/fehler-box.component';
import {LoadingComponent} from './components/loading/loading.component';
import {AccordionComponent} from './components/accordion/accordion.component';
import {NachweiseInfoComponent} from './components/nachweise-info/nachweise-info.component';
import {PiwikModule} from '@wba/commons/modules/piwik';
import {IosDownloadDialogComponent} from '@wba-ui-module/components/dialogs/ios-download-dialog/ios-download-dialog.component';
import {DownloadLinkComponent} from '@wba-ui-module/components/download-link/download-link.component';
import {AntragSpaeterFortsetzenDialogComponent} from '@wba-ui-module/components/dialogs/antrag-spaeter-fortsetzen-dialog/antrag-spaeter-fortsetzen-dialog.component';
import {TechnischerFehlerDialogComponent} from './components/dialogs/technischer-fehler-dialog/technischer-fehler-dialog.component';
import {ConcatenatePipe} from './pipes/concatenate.pipe';
import {ChangelogBoxComponent} from './components/changelog-box/changelog-box.component';
import {WbaAntragVersionPipe} from '../../pipes/wba-antrag-version.pipe';
import {VersionedTextBlockComponent} from './components/versioned-text-block/versioned-text-block.component';
import {WbaUeberschriftKachelComponent} from './components/headings/wba-ueberschrift-kachel/wba-ueberschrift-kachel.component';
import {IMaskDirective} from 'angular-imask';


@NgModule({
  imports: [
    TranslateModule.forChild(),
    RouterModule,
    FormsModule,
    IMaskDirective,
    CommonModule,
    PiwikModule,
    ReactiveFormsModule
  ],
  declarations: [
    AccordionComponent,
    CheckboxComponent,
    PanelComponent,
    InputComponent,
    SelectComponent,
    KachelComponent,
    JaNeinRadioComponent,
    DatepickerComponent,
    NichtVorhandenDirective,
    FragezeichenComponent,
    ButtonLeisteComponent,
    ErrorMessageComponent,
    ModalDialogComponent,
    TextareaComponent,
    InputSuggestionComponent,
    GeoFilterPipe,
    LoeschenDialogComponent,
    FileUploadComponent,
    ProgressNavigationComponent,
    HideExtPipe,
    FehlerBoxComponent,
    LoadingComponent,
    NachweiseInfoComponent,
    IosDownloadDialogComponent,
    DownloadLinkComponent,
    AntragSpaeterFortsetzenDialogComponent,
    TechnischerFehlerDialogComponent,
    ConcatenatePipe,
    ChangelogBoxComponent,
    WbaAntragVersionPipe,
    VersionedTextBlockComponent,
    WbaUeberschriftKachelComponent
  ],
  exports: [
    AccordionComponent,
    CheckboxComponent,
    PanelComponent,
    InputComponent,
    SelectComponent,
    KachelComponent,
    JaNeinRadioComponent,
    DatepickerComponent,
    NichtVorhandenDirective,
    FragezeichenComponent,
    ButtonLeisteComponent,
    ErrorMessageComponent,
    ModalDialogComponent,
    TextareaComponent,
    InputSuggestionComponent,
    GeoFilterPipe,
    LoeschenDialogComponent,
    FileUploadComponent,
    ProgressNavigationComponent,
    HideExtPipe,
    FehlerBoxComponent,
    LoadingComponent,
    NachweiseInfoComponent,
    IosDownloadDialogComponent,
    DownloadLinkComponent,
    AntragSpaeterFortsetzenDialogComponent,
    TechnischerFehlerDialogComponent,
    ConcatenatePipe,
    WbaAntragVersionPipe,
    ChangelogBoxComponent,
    VersionedTextBlockComponent,
    WbaUeberschriftKachelComponent,
  ],
  providers: [
    DateConverterService,
    WbaAntragVersionPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WbaUiModule {
}
